import React, { useState, useEffect } from "react";
import "./login.css";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { database } from "../../database/firebase";
import { getFirestore, increment, serverTimestamp, doc, getDoc, updateDoc, addDoc, setDoc, collection, query, orderBy, where, getDocs, onSnapshot, listCollections, Timestamp } from "firebase/firestore";
import axios from "axios";
import Swal from 'sweetalert2';
import { checkTeams } from "../../teamservice";

function Login({ updateHeader }) {
  const location = useLocation();

  // Use URLSearchParams to access the query parameters
  const queryParams = new URLSearchParams(location.search);
  const getOtp = queryParams.get('otp');
  const role = queryParams.get('role');
  const [otp, setOtp] = useState(getOtp);
  const [isLoggedIn, setIsLoggedIn] = useState(false); // To control login state
  const [themeData, setThemeData] = useState(null);
  const [riddlerusLogo, setRiddlerusLogo] = useState("/img/logo.png");
  const navigate = useNavigate();
  const [isLogoSet, SetIsLogoSet] = useState(false);
  const [teamName, SetTeamName] = useState();
  const [isAgeConfirmed, setIsAgeConfirmed] = useState(false);

  const handleSuccess = (msg) => {
    Swal.fire({
      title: 'Success!',
      text: msg,
      customClass: {
        popup: 'custom-success-popup' // Apply your custom class
      }
    });
  };

  const handleError = (msg) => {
    Swal.fire({
      title: 'Oops...',
      text: msg,
      customClass: {
        popup: 'custom-success-popup' // Apply your custom class
      }
    });
  };
  function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
  function generateRandomUser() {
    const randomString = 'demo' + Math.floor(Math.random() * 10000);
    return {
      data: {
        data: {
          id: Math.floor(Math.random() * 100000),
          email: `${randomString}@gmail.com`,
          userId: randomString,
          firstName: randomString,
          lastName: randomString,
          employeeId: `EM${Math.floor(Math.random() * 1000).toString().padStart(3, '0')}`,
          sessionId: "demobypass",
          organizationId: "demobypass",
          roles: "demoRoles",
          reportId: `Report${Math.floor(Math.random() * 1000).toString().padStart(3, '0')}`
        }
      }
    };
  }
  const handleLogin = () => {
    if (queryParams.get('save')) {
      console.log("ignoring latest update...");
    } else {

      if (queryParams.get('demo') === 'true') {
        // const userId=;
        // const email=;
        // const firstName=;
        const response = generateRandomUser();

        loginCheck(response, "demo");
      } else {

        let apiUrl;
        const requestData = { otp: otp };
        let source = null;

        if (role === 'GUEST_USER') {
          apiUrl = process.env.REACT_APP_FIREBASE_GUEST_USER_API;
          requestData.role = 'GUEST_USER';
          source = 'GUEST_USER'
        } else {
          apiUrl = process.env.REACT_APP_FIREBASE_LOGIN_API;
          source = 'ORG_USER'
        }


        const headers = {
          'client-secret': process.env.REACT_APP_FIREBASE_CLIENT_SECRET,
          'Content-Type': 'application/json'
        };

        const method = "POST";
        if (["POST", "PUT"].includes(method)) {
          headers["Idempotency-Key"] = uuidv4();
          console.log("Added Idempotency-Key:", headers["Idempotency-Key"]);
        }
        // const headers = {
        //   'Content-Type': 'application/json'
        // };

        console.log(apiUrl);
        axios.post(apiUrl, requestData, { headers })
          .then(response => {
            console.log("API TRIGGER", response);
            if (response.data.message === 'LOGIN SUCCESS') {
              axios.get(
                process.env.REACT_APP_ORG_API + "/" + response.data.data.organizationId,
                { headers } // Ensure headers are included properly
              )
                .then(responseOrg => {
                  if (responseOrg.data.message === 'ORGANIZATIONS_FETCHED_SUCCESSFULLY') {
                    let companyLogo = process.env.REACT_APP_S3BUCKET_URL + '/' + responseOrg.data.organization.companyLogo;
                    console.log("companyLogo", companyLogo);
                    console.log("responseOrg", responseOrg);
                    if (typeof updateHeader === "function") {
                      try {
                        updateHeader({
                          imageUrl: companyLogo,
                          backButtonRedirect: process.env.REACT_APP_BASE_URL + "/game-detail/" + response.data.data.gameId,
                        });
                      } catch (err) {
                        console.error("updateHeader threw:", err, updateHeader);
                      }
                    } else {
                      console.error("updateHeader is not a function — aborting updateHeader call:", updateHeader);
                    }
                    // updateHeader({
                    //   imageUrl: companyLogo,
                    //   backButtonRedirect: process.env.REACT_APP_BASE_URL + "/game-detail/" + response.data.data.gameId,
                    // });
                  }
                  console.log("responseOrg", responseOrg);
                })
                .catch(error => {
                  console.error("Error fetching organization:", error);
                });

              if (queryParams.get('admin')) {
                window.location.href =
                  `${process.env.REACT_APP_ADMIN_REDIRECT}?sessionId=${response.data.data.sessionId}&userId=${response.data.data.userId}&organizationId=${response.data.data.organizationId}`;
              } else {
                loginCheck(response, source);
              }
            } else {
              handleError('Login failed! Please try again.');
            }

          })
          .catch(error => {
            console.error('Login Failed:', error.response?.data?.err?.message || 'An error occurred');
            handleError('Login failed! Please try again.');

          });
      }
    }
  };

  async function loginCheck(response, source) {
    try {
      const data = response.data.data;
      console.log("loginCheck:", data);
      // if(source=="GUEST_USER"){
      //   data.role=data.role;
      // }else{
      //   data.role
      // }

      // 1️⃣ Extract core user info
      const isGuest = source === "GUEST_USER";
      const userId = isGuest ? data.id : data.userId;

      let name = `${data.firstName || ""} ${data.lastName || ""}`.trim();
      let email = data.email || data.employeeId || "";
      let token = isGuest ? "" : data.token;

      if (isGuest && !data.firstName) {
        if (data.email) name = data.email.split("@")[0];
        else if (data.employeeId) name = data.employeeId;
        else name = "Guest";
      }

      // 2️⃣ Check team info
      const checkData = {
        sessionId: data.sessionId,
        organizationId: data.organizationId,
        email: data.email,
      };

      const res = await checkTeams(checkData);
      console.log("Team check:", res);

      const team = res.status === "exists" ? res.data.team : "NULL";
      if (res.status !== "exists") SetTeamName("NULL");

      // 3️⃣ Build userData
      const userData = {
        userId,
        sessionId: data.sessionId,
        organizationId: data.organizationId,
        roles: source,
        teamName: team,
        name,
        email,
        expiry: Date.now() + 24 * 60 * 60 * 1000,
        source,
        token,
      };

      console.log("Prepared userData:", userData);

      const userDocRef = doc(database, `sessions/${userData.sessionId}/users/${userData.userId}`);
      const userSnapshot = await getDoc(userDocRef);

      // 4️⃣ Handle admin redirect first
      if (queryParams.get("admin")) {
        window.location.href = `${process.env.REACT_APP_ADMIN_REDIRECT}?sessionId=${userData.sessionId}&userId=${userData.userId}&organizationId=${userData.organizationId}`;
        return;
      }

      // 5️⃣ If user exists
      if (userSnapshot.exists()) {
        const userDocData = userSnapshot.data();
        console.log("User exists:", userDocData);

        if (userDocData.reportId) {
          // ✅ Existing reportId found → just save and proceed
          console.log("Existing reportId:", userDocData.reportId);
          const updatedUserData = { ...userData, reportId: userDocData.reportId };
          sessionStorage.setItem("userData", JSON.stringify(updatedUserData));
          setIsLoggedIn(true);
        }
      } else {
        // 6️⃣ User does not exist → create user first, then generate report
        await setDoc(userDocRef, {
          userId: userData.userId,
          organizationId: userData.organizationId,
          sessionId: userData.sessionId,
          teamName: userData.teamName,
          name: userData.name,
          email: userData.email,
          timestamp: Date.now(),
          source: userData.source,
          roles: userData.roles,
          token: userData.token,
        });

        console.log("User document created successfully.");
        await callReportAPIAndContinue(userData, response);
      }

      // 7️⃣ Fetch theme data for this user
      await fetchThemeData(userData);

    } catch (error) {
      console.error("Error in loginCheck:", error);
      handleError("There was an error during login. Please try again.");
    }

    // --------------------------------------------------
    // 📦 Helper: Report API and Firestore update
    // --------------------------------------------------
    async function callReportAPIAndContinue(userData, response) {
      try {
        const isGuest = userData.roles === "GUEST_USER";

        const reportUrl = isGuest
          ? process.env.REACT_APP_GUEST_REPORT_URL
          : process.env.REACT_APP_REPORT_URL;

        const reportRequestData = isGuest
          ? {
            gameId: response.data.data.gameId,
            name: userData.name,
            sessionId: userData.sessionId,
            userId: userData.userId,
            organizationId: userData.organizationId,
            points: 50000,
            time: "NA",
            ans: "",
          }
          : {
            points: 50000,
            time: "NA",
          };

        let headers = {
          "client-secret": process.env.REACT_APP_FIREBASE_CLIENT_SECRET,
          "Content-Type": "application/json",
        };

        if (!isGuest) {
          headers["Authorization"] = `Bearer ${userData.token}`;
        }

         const method = "POST";
      if (["POST", "PUT"].includes(method)) {
        headers["Idempotency-Key"] = uuidv4();
        console.log("Added Idempotency-Key:", headers["Idempotency-Key"]);
      }


        const reportResponse = await axios.post(reportUrl, reportRequestData, { headers });
        console.log("reportResponse--", reportResponse);

        let reportId = null;

        if (isGuest && reportResponse.data.message === "Score added successfully") {
          reportId = reportResponse.data.data.id;
        }
        else if (!isGuest && reportResponse.data.message === "REPORT ADDED SUCCESSFULLY") {
          reportId = reportResponse.data.data.reportId;
        }
        if (reportId) {
          //updatedUserData.reportId = reportId;

          // const reportId = reportResponse.data.data.reportId;
          console.log("✅ Report created successfully:", reportId);

          // Update Firestore with reportId
          const userDocRef = doc(database, `sessions/${userData.sessionId}/users/${userData.userId}`);
          console.log("userDocRef--", userDocRef);

          await updateDoc(userDocRef, { reportId });

          console.log("Firestore updated with reportId:", reportId);

          // Update local data
          const updatedUserData = { ...userData, reportId };
          console.log("updatedUserData--", updatedUserData);
          sessionStorage.setItem("userData", JSON.stringify(updatedUserData));
          setIsLoggedIn(true);
        } else {
          console.warn("Report creation did not return success:", reportResponse.data);
        }
      } catch (error) {
        console.error("Report API Error:", error.response?.data?.err?.message || error.message);
        handleError("Unable to create report. Please try again.");
      }
    }

    // --------------------------------------------------
    // 🎨 Helper: Fetch Theme Data
    // --------------------------------------------------
    async function fetchThemeData(userData) {
      try {
        const themeUrl = `${process.env.REACT_APP_FETCH_THEMEDATA}?sessionId=${userData.sessionId}&userId=${userData.userId}&organizationId=${userData.organizationId}`;
        const response = await fetch(themeUrl);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const json = await response.json();
        setThemeData(json);
        sessionStorage.setItem("themeData", JSON.stringify(json));
        CheckThemeSet(userData.sessionId, json);
        console.log("Theme data loaded:", json);
      } catch (err) {
        console.error("Error fetching theme data:", err);
      }
    }
  }

  async function CheckThemeSet(sessionId, stockArray) {
    if (!stockArray.stock || stockArray.stock.length === 0) {
      console.error("Stock data is empty or undefined. Cannot proceed.");
      return;
    }

    const gameRef = doc(database, `sessions/${sessionId}/themes/${stockArray.themeName}`);

    try {
      // Get the document snapshot
      const docSnapshot = await getDoc(gameRef);

      if (docSnapshot.exists()) {
        const gameData = docSnapshot.data();
        console.log("Game Data:", gameData);
        setIsLoggedIn(true);
      } else {
        console.warn("Game session document does not exist. Creating new session...");

        // Create the document with default values if it doesn't exist
        await setDoc(gameRef, {
          ...stockArray.stock,
          sessionId,
          date: serverTimestamp(), // ✅ Adds timestamp
        });

        console.log("New game session document created.");
        CheckCompanyExists(sessionId, stockArray.companies, stockArray.themeName);
        CheckNewsExists(sessionId, stockArray.news, stockArray.themeName);
        console.log("news", stockArray.news);

      }
    } catch (error) {
      console.error("Error checking or creating game session document:", error);
    }

  }

  async function CheckCompanyExists(sessionId, companiesArray, themenameval) {
    if (!companiesArray || companiesArray.length === 0) {
      console.error("Companies data is empty or undefined. Cannot proceed.");
      return;
    }

    const companiesCollectionRef = collection(database, "companies");

    try {
      // Query Firestore to check if any document with the given sessionId exists
      const q = query(
        companiesCollectionRef,
        where("sessionId", "==", sessionId),
        where("themename", "==", themenameval) // <-- Add your second condition here
      );
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        console.log(`Companies collection already contains data for sessionId: ${sessionId}. No new entries will be added.`);
        return;
      }

      console.log(`No companies found for sessionId: ${sessionId}. Adding new entries...`);

      // Add each company as a separate document
      const addCompaniesPromises = companiesArray.map((companyItem) =>
        addDoc(companiesCollectionRef, {
          ...companyItem,
          sessionId,
          "themename": themenameval,
          date: serverTimestamp(), // ✅ Adds timestamp
        })
      );

      // ✅ Ensure all documents are added before setting logged-in status
      await Promise.all(addCompaniesPromises);

      console.log("All company documents added successfully.");
      setIsLoggedIn(true); // ✅ Set login status only after all documents are added

    } catch (error) {
      console.error("Error handling companies collection:", error);
    }
  }

  async function CheckNewsExists(sessionId, newsArray, themenameval) {
    console.log("newsArray", newsArray);

    if (!newsArray || newsArray.length === 0) {
      console.error("News data is empty or undefined. Cannot proceed.");
      return;
    }

    const newsCollectionRef = collection(database, "news"); // ✅ Correct collection reference

    try {
      // ✅ Query Firestore to check if any document with the given sessionId exists
      const q = query(newsCollectionRef,
        where("sessionId", "==", sessionId),
        where("themename", "==", themenameval) // <-- Add your second condition here
      );
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        console.log(`News collection already contains data for sessionId: ${sessionId}. No new entries will be added.`);
        return;
      }

      console.log(`No news found for sessionId: ${sessionId}. Adding new entries...`);

      // ✅ Add each news item as a separate document
      const addNewsPromises = newsArray.map((newsItem) =>
        addDoc(newsCollectionRef, {
          ...newsItem,
          sessionId,
          "themename": themenameval,
          date: serverTimestamp(), // ✅ Adds timestamp
        })
      );

      const addedDocs = await Promise.all(addNewsPromises);
      addedDocs.forEach((docRef) => console.log(`Added news document with ID: ${docRef.id}`));

      // ✅ Set login state if required


    } catch (error) {
      console.error("Error handling news collection:", error);
    }
  }

  useEffect(() => {
    // First-time login
    const storedUserData = JSON.parse(sessionStorage.getItem('userData'));
    if (storedUserData) {
      sessionStorage.removeItem('userData');
    }
    handleLogin();
    Swal.fire({
      title: 'Are you 18+?',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      allowOutsideClick: false,
      allowEscapeKey: false,
      heightAuto: false,
      scrollbarPadding: false,
      backdrop: 'rgba(47, 74, 82, 0.15)',
      customClass: {
        container: 'age-confirm-container',
        popup: 'age-confirm-popup',
        title: 'age-confirm-title',
        confirmButton: 'age-confirm-yes',
        cancelButton: 'age-confirm-no',
        actions: 'age-confirm-actions'
      }
    }).then((result) => {
      if (result.isConfirmed) {
        setIsAgeConfirmed(true);
      } else {
        window.location.href = process.env.REACT_APP_BASE_URL;
      }
    });
  }, []); // Runs once on component mount

  useEffect(() => {
    if (themeData) {
      const body = document.body;

      const backgroundImage = window.innerWidth <= 768 ? themeData.background_mob : themeData.background_desk;
      if (body.classList.contains('common-bg')) {
        body.style.backgroundImage = `url(${backgroundImage})`;
      }
      setRiddlerusLogo(themeData.logo);
      SetIsLogoSet(true);
    }
  }, [themeData]);


  useEffect(() => {
    setTimeout(function () {
      if (queryParams.get('save')) {
        let getThemeData = sessionStorage.getItem('themeData');
        getThemeData = JSON.parse(getThemeData);
        console.log(getThemeData);
        let body = document.body;
        setIsLoggedIn(true);
        if (getThemeData) {
          if (body.classList.contains('common-bg')) {
            console.log(getThemeData.background_desk);
            console.log(getThemeData.logo);
            body.style.backgroundImage = `url(${getThemeData.background_desk})`;
            setRiddlerusLogo(getThemeData.logo);
            SetIsLogoSet(true);
          } else {
            console.log("not able to find common bg");
          }
          console.log("sessioin state updated!");
        }
      }
    }, 1000);
  }, []);

  return (
    <>
      <div className="login-main-container" style={{ textAlign: "center" }}>

        {
          (isLogoSet) ?
            <div className="login-main-container1" style={{ textAlign: "center" }}>
              <img src={riddlerusLogo} className="login-logo" />
            </div>
            :
            <>
              <div className="loader">
                <div className="bar"></div>
                <div className="bar"></div>
                <div className="bar"></div>
              </div>
            </>

        }
        {isLoggedIn && isAgeConfirmed ? (
          <div style={{ textAlign: "center" }}>
            <Link to="/intro">
              <img src="/img/next-button.png" className="begin-play-img1" alt="Begin Play" />
            </Link>
          </div>
        ) : (
          <></>
        )}
      </div>
    </>
  );
}

export default Login;